import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BadgeHeadingsExample } from "../../../../Constant";
import { BADGE_EX_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";
import { H1, H2, H3, H4, H5, H6 } from "../../../../AbstractElements";

const BadgeHeadingsExampleCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BadgeHeadingsExample} span={BADGE_EX_DATA} />
        <CardBody>
          <H1 className="pb-2 d-flex gap-2 flex-wrap">Badge Heading 1<span className="badge badge-primary">Latest</span></H1>
          <H2 className="pb-2 d-flex gap-2 flex-wrap">Badge Heading 2<span className="badge badge-secondary">Trending</span></H2>
          <H3 className="pb-2 d-flex gap-2 flex-wrap">Badge Heading 3<span className="badge badge-success">Checkout</span></H3>
          <H4 className="pb-2 d-flex gap-2 flex-wrap">Badge Heading 4<span className="badge badge-warning">Inbox</span></H4>
          <H5 className="pb-2 d-flex gap-2 flex-wrap">Badge Heading 5<span className="badge badge-danger">Login</span></H5>
          <H6 className="pb-2 d-flex gap-2 flex-wrap">Badge Heading 6<span className="badge badge-dark">Logout</span></H6>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BadgeHeadingsExampleCart;